import { PSPContentMap, PSPKeywordMap } from "config/pspContentMap";

export const normalizeKeyword = (keyword) => {
	if (typeof keyword !== "string") {
		return "";
	}

	let normalizedKeyword = keyword
		.trim()
		.toLowerCase()
		.replace(/\.html$/, "")
		.replace(/\/$/, "");

	if (PSPKeywordMap[normalizedKeyword]) {
		return PSPKeywordMap[normalizedKeyword];
	}

	if (normalizedKeyword.endsWith("-storage-units")) {
		normalizedKeyword = normalizedKeyword.replace(/-storage-units$/, "");
	}

	return normalizedKeyword;
};

export const getPSPContent = (keyword) => {
	if (!keyword) return null;
	return PSPContentMap[keyword] || null;
};

/**
 * Check if a keyword has corresponding PSP content
 * @param {string} keyword - The keyword to check
 * @returns {boolean} True if the keyword has content
 */
export function hasPSPContentSSR(keyword) {
	const resolvedKeyword = normalizeKeyword(keyword);
	return Boolean(
		resolvedKeyword &&
		Object.prototype.hasOwnProperty.call(PSPContentMap, resolvedKeyword)
	);
}
